import {Truncate} from '@dropbox/dig-components/truncate';
import {Text} from '@dropbox/dig-components/typography';
import {Stack, withShade} from '@dropbox/dig-foundations';
import {TeamLine} from '@dropbox/dig-icons/assets';
import {TeamWithCountsNew} from 'client';
import {AvatarIcon} from 'components/DSYS/Avatar';
import {t} from 'i18next';

import styles from './SearchBox.module.css';
import {SearchRow} from './searchRows';
import {Label} from './Typography';

/** A profile's team as a search row, so the panel can open it in place. */
const teamRow = (team: TeamWithCountsNew): SearchRow => ({
  kind: 'team',
  id: `team:${team.team_id}`,
  team: {...team, members_count: team.total_employee_count},
});

export const peopleCount = (count: number) => t('search_box_people_count', {count});

/**
 * The teams someone is on, as full-width filled cards (one per line, like a
 * meeting's People rows): the team's glyph, its name over its size. Clicking
 * one opens it (in the panel when `onSelect` is given).
 */
export const TeamCards = ({
  teams,
  onSelect,
}: {
  teams: TeamWithCountsNew[];
  onSelect: (row: SearchRow) => void;
}) =>
  teams.length > 0 ? (
    <Stack gap="12">
      <Label>{teams.length === 1 ? t('team') : t('teams')}</Label>
      <Stack gap="8">
        {teams.map((team) => (
          <div
            key={team.team_id}
            {...withShade({className: `${styles.card} ${styles.surface}`})}
            onClick={() => onSelect(teamRow(team))}
          >
            <AvatarIcon src={TeamLine} size="medium" />
            <div className={styles.cardText}>
              <Text size="small" isBold tagName="div">
                <Truncate>{team.name ?? t('team')}</Truncate>
              </Text>
              <Text size="small" color="subtle" tagName="div">
                {peopleCount(team.total_employee_count)}
              </Text>
            </div>
          </div>
        ))}
      </Stack>
    </Stack>
  ) : null;
